// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8197) return "static/chunks/8197.cbb0e9562b13c7a6.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"86":"072f29afe9a76a91","2898":"1792dad1d4523f09","5455":"dab8fe2becef0fb9","5564":"78396f110038404c","9185":"a25c40d83a814a87"}[chunkId] + ".js";
};